import React from "react";
import "../Styles/home.css";

import icon1 from "../assests/images/home-person.png";
import icon3 from "../assests/images/perpect-match.png";
import icon4 from "../assests/images/match-support.png";
import icon2 from "../assests/images/mutual-conn.png";
import homeFam from "../assests/images/home-fam.png";

export default function HowItWorks() {
  return (
    <section className="how-it-works-container">
      <div className="border-horizontal-line"></div>
      <div className="how-it-works">
        <h2 className="section-title-how-it-works">How Wedluk works ?</h2>
        <div className="work-steps">
          <div className="step">
            <div className="icon-wrapper">
              <img src={icon1} alt="Network Icon" />
              <div className="step-line"></div>
            </div>
            <div>
              <h3>
                Agents: Start and Grow Your Local Matrimonial Agency Business
              </h3>
              <p>
                {/* Bride, groom, or parent—join a privacy-focused network where you{" "}
                <strong>can search for matches on your own</strong> or opt to{" "}
                <strong>work with a dedicated agent</strong> who guides you
                every step of the way. */}
                Agents can use WedLuk as a personal matchmaking platform while
                also joining the WedLuk Agent Network—automatically connecting
                with other agents across regions and abroad to expand their
                reach and grow their business.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="icon-wrapper home-fam-wrapper">
              <img
                className="home-fam"
                src={homeFam}
                alt="Family with father, mother, and son"
              />
              <div className="step-line"></div>
            </div>
            <div>
              <h3>
                {" "}
                Family,Individuals: Join a Secure, Location-Based, Privacy‑Focused
                Network
              </h3>
              <p>
                Whether you’re a bride, groom, or parent, you can enter a
                privacy‑focused community where you may explore matches on your
                own or partner with a dedicated agent who guides you through
                every step of the process.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="icon-wrapper">
              <img src={icon4} alt="Support Icon" />
              <div className="step-line"></div>
            </div>
            <div>
              <h3>
                {" "}
                Personalized Match Support Powered by Human Insight and
                Intelligent Automation
              </h3>
              <p>
                Your dedicated agent will help you build a strong profile,
                identify compatible matches, and offer guidance aligned with
                your preferences. Our automated AI system will also notify every
                one of the new matches so they can take the next step.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="icon-wrapper">
              <img src={icon2} alt="Verify Icon" />
              <div className="step-line"></div>
            </div>
            <div>
              <h3>Verify Matches Using Real Connections in Your Network</h3>
              <p>
                For enhanced trust and security, you can use mutual contacts and
                contacts of your contacts to verify potential matches within
                your extended network.
              </p>
            </div>
          </div>

          <div className="step">
            <div className="icon-wrapper">
              <img src={icon3} alt="Heart Icon" />
              {/* No step-line on last one */}
            </div>
            <div>
              <h3>Find the Partner Who Complements Your Life Journey</h3>
              <p>
                With <strong> expert guidance and trusted connections</strong>,
                you are empowered to discover and meet the ideal partner for
                your life journey.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
